import React from 'react';

import Box, { BoxProps } from 'components/@ui/Box';

const MobileHeatMapViewWrapper: React.FC<BoxProps> = (props) => (
  <Box display="flex" flexDirection="column" gap="12px 0" width={1} {...props} />
);

export default React.memo(MobileHeatMapViewWrapper);
